const LEGACY_PRODUCT_CATEGORY_LABELS: Record<string, string> = {
  '0': 'Sin categoría',
  '21': 'Accesorios para roedores',
  '24': 'Alimento seco para gatos',
  '25': 'Comederos y bebederos',
  '26': 'Transportadoras y camas',
  '27': 'Peluquería',
  '29': 'Alimento húmedo para gatos',
  '30': 'Juguetes para gatos',
  '31': 'Arenas y sanitarios',
  '33': 'Acuarios',
  '34': 'Alimento para peces',
  '37': 'Higiene y dermatología',
  '38': 'Correas, pretales y bozales',
  '39': 'Alimento seco para perros',
  '41': 'Camas',
  '44': 'Higiene',
  '45': 'Alimento húmedo y snacks para perros',
  '46': 'Juguetes para perros',
  '50': 'Indumentaria',
  '60': 'Antiparasitarios ambientales',
  '61': 'Vacunas',
  '62': 'Antiparasitarios externos',
  '64': 'Medicamentos veterinarios',
  '70': 'Medicamentos veterinarios',
  '109': 'Alimento para pequeños animales',
  '110': 'Accesorios para roedores',
  '122': 'Higiene y accesorios',
};

const PRODUCT_CATEGORY_ALIASES: Record<string, string> = {
  'alimento perro': 'Alimento seco para perros',
  'alimento gato': 'Alimento seco para gatos',
  'alimento suelto perro': 'Alimento suelto para perros',
  'alimento suelto perros': 'Alimento suelto para perros',
  'alimento suelto gato': 'Alimento suelto para gatos',
  'alimento suelto gatos': 'Alimento suelto para gatos',
  medicamento: 'Medicamentos veterinarios',
  medicamentos: 'Medicamentos veterinarios',
  'medicamentos veterinarios': 'Medicamentos veterinarios',
  'antiparasitario externo': 'Antiparasitarios externos',
  'antiparasitarios externos': 'Antiparasitarios externos',
  'antiparasitario interno': 'Antiparasitarios internos',
  'antiparasitarios internos': 'Antiparasitarios internos',
};

export const PRODUCT_CATEGORY_OPTIONS = [
  'Alimento seco para perros',
  'Alimento seco para gatos',
  'Alimento húmedo para perros',
  'Alimento húmedo para gatos',
  'Alimento húmedo y snacks para perros',
  'Alimento suelto para perros',
  'Alimento suelto para gatos',
  'Alimento para peces',
  'Alimento para pequeños animales',
  'Sueltos',
  'Snacks',
  'Medicamentos veterinarios',
  'Vacunas',
  'Inyectables',
  'Antiparasitarios externos',
  'Antiparasitarios internos',
  'Antiparasitarios ambientales',
  'Higiene',
  'Higiene y dermatología',
  'Peluquería',
  'Peluquería canina',
  'Baño',
  'Corte',
  'Consultorio',
  'Arenas y sanitarios',
  'Accesorios',
  'Comederos y bebederos',
  'Correas, pretales y bozales',
  'Transportadoras y camas',
  'Camas',
  'Juguetes para perros',
  'Juguetes para gatos',
  'Accesorios para roedores',
  'Acuarios',
  'Indumentaria',
  'Higiene y accesorios',
  'Sin categoría',
  'Categoría importada',
];

const DEFAULT_LOYALTY_EXCLUDED_CATEGORIES = new Set([
  'consultorio',
  'vacunas',
  'inyectables',
  'peluqueria',
  'peluqueria canina',
  'bano',
  'corte',
]);

function normalizeCategoryKey(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function earnsLoyaltyPointsByDefault(value: unknown): boolean {
  return !DEFAULT_LOYALTY_EXCLUDED_CATEGORIES.has(normalizeCategoryKey(String(value ?? '')));
}

export function normalizeProductCategory(value: unknown): string {
  const category = String(value ?? '').trim();
  if (!category) return '';
  if (/^\d+$/.test(category) && !LEGACY_PRODUCT_CATEGORY_LABELS[category]) {
    return 'Categoría importada';
  }

  const legacyOrCurrent = LEGACY_PRODUCT_CATEGORY_LABELS[category] ?? category;
  return PRODUCT_CATEGORY_ALIASES[normalizeCategoryKey(legacyOrCurrent)] ?? legacyOrCurrent;
}

const KILOGRAM_UNITS = new Set(['kg', 'kilo', 'kilos', 'kilogramo', 'kilogramos']);

export function isProductSoldByKg(value: unknown): boolean {
  const unit = String(value ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\./g, '')
    .trim();

  return KILOGRAM_UNITS.has(unit);
}
